import { Icons } from "../../../../design_system/components/Icons";
import ConditionalRender from "../../../../ConditionalRender";
import { handleNewsImageError } from "../../../utils/newsImageFallback.js";

const PostPreview = ({ article, isOpen, onToggle }) => {
    return (
        <>
            <div className="publish-popup__preview-divider"></div>
            <div
                className="flex items-center justify-between cursor-pointer publish-popup__preview-header"
                onClick={onToggle}
            >
                <div className="body-m-bold color-text-primary publish-popup__preview-label-text">Post preview
                    <Icons style={{ marginLeft: "var(--space-s)", cursor: "pointer" }}
                        name={isOpen ? "chevron-up" : "chevron-down"}
                        size={24}
                    />
                </div>
            </div>
            <ConditionalRender if={isOpen}>
                <div className="publish-popup__preview-content">
                    <a
                        href={article.url}
                        target="_blank"
                        className="publish-popup__article-preview"
                    >
                        {article.image_url && (
                            <img src={article.image_url} className="newsfeed__post-image" onError={handleNewsImageError} />
                        )}
                        <div className="overflow-hidden">
                            <div className="body-m-bold block no-underline newsfeed__post-title newsfeed__post-title--mb-xs">
                                {article.title}
                            </div>
                            <div className="body-s-semibold newsfeed__post-desc">
                                {article.description}
                            </div>
                        </div>
                    </a>
                </div>
            </ConditionalRender>
        </>
    );
};

export default PostPreview;
